import { render, staticRenderFns } from "./simple-text-editor.vue?vue&type=template&id=5f9b3944"
import script from "./simple-text-editor.vue?vue&type=script&lang=js"
export * from "./simple-text-editor.vue?vue&type=script&lang=js"
import style0 from "./simple-text-editor.vue?vue&type=style&index=0&id=5f9b3944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports